<template>
  <div class="main-container">
    <p class="loading-text">授权处理中，请稍候...</p>
  </div>
</template>

<script>
import { verifyFaDaDaAuthCallbackApi } from '@/apis/credit'
import { antiFraudApi } from '@/apis/userCenter'

export default {
  created() {
    this.handleAuthCallback()
  },
  methods: {
    async handleAuthCallback() {
      const {
        timestamp,
        clientUserId,
        openUserId,
        authResult,
        authFailedReason,
        authScope,
        signature,
        nextType,
      } = this.$route.query || {}

      if (!timestamp || !signature) {
        this.$common.toast('授权参数缺失')
        this.$router.replace('/upload-idCard')
        return
      }

      try {
        const res = await verifyFaDaDaAuthCallbackApi({
          timestamp,
          clientUserId,
          openUserId,
          authResult,
          authFailedReason,
          authScope,
          signature,
        })
        if (res.code === 200 && res.data === true) {
          if (nextType === 'antiFraud') {
            const d = await antiFraudApi({ businessType: 'kdb' })
            if (d.code === 200) {
              const result = d.data.result
              this.$router.replace(`/anti-fraud-result?result=${result}`)
              return
            }
          } else {
            this.$router.replace('/borrow-info')
            return
          }
        }
        this.$common.toast('授权失败，请重新操作')
        this.$router.replace('/upload-idCard')
      } catch (e) {
        this.$common.toast('授权处理异常，请重新操作')
        this.$router.replace('/upload-idCard')
      }
    },
  },
}
</script>

<style scoped lang="less">
.main-container {
  padding-top: 2rem;
}
.loading-text {
  text-align: center;
  color: #333;
  font-size: 0.32rem;
}
</style>
